import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { TextField } from '@tempmee/react';
import { SectionEditDialog } from '~/components/shared/AccountArea';
import { buildContactPatch, toSectionDefaults, useUpdateLocation } from '~/domain/LocationSettings';
import type { ISectionModalProps } from './types';

/** Website only: location phone, location email and billing email wait for a backend. */
export const ContactModal = ({ officeId, office, onClose, onSaved }: ISectionModalProps) => {
  const defaultValues = useMemo(() => toSectionDefaults(office, null).contact, [office]);
  const { control, handleSubmit, formState } = useForm({ defaultValues });
  const updateLocation = useUpdateLocation(officeId);

  const save = handleSubmit(async (values) => {
    await updateLocation.mutateAsync(buildContactPatch(values));
    onSaved();
  });

  return (
    <SectionEditDialog
      title="Edit Contact"
      dataCy="edit-contact"
      onClose={onClose}
      onSave={save}
      canSave={formState.isDirty}
    >
      <Controller
        name="website"
        control={control}
        render={({ field }) => (
          <TextField label="Website (Optional)" data-cy="location-website" {...field} />
        )}
      />
    </SectionEditDialog>
  );
};
